var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('al-button',{attrs:{"type":_vm.type,"plain":_vm.plain,"round":_vm.round,"circle":_vm.circle,"icon":_vm.icon,"disabled":_vm.disabled,"loading":_vm.loading||(_vm.blockClick)},on:{"click":_vm._click}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-15e315f0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./UI/Button/ThrottleButton.vue
// module id = 260
// module chunks = 0